/** Trim text to a search-snippet length at a word boundary. */
export function clampText(text, max = 158) {
  const t = String(text || "").replace(/\s+/g, " ").trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1).replace(/[\s,.;:&-]+\S*$/, "").trim()}…`;
}

/** Oxford-free natural list: "A, B and C". */
export function joinNames(list) {
  const a = list.filter(Boolean);
  return a.length > 1 ? `${a.slice(0, -1).join(", ")} and ${a[a.length - 1]}` : a[0] || "";
}
